


import { Modal } from 'bootstrap';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import uuid from 'react-uuid';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import Loader from '../../../components/ui/Loader/Loader';
import DateService from '../../../services/DateService';
import HttpAPICall from '../../../services/HttpAPICall';
import { IAM_API_BASE_URL_2, IAM_COUNTERLOG_URL } from '../../../services/TapApiUrls';
import TapIcon from '../../../services/TapIcon';
import DataService from '../../../services/DataService';
import TapHelper from '../../../services/TapHelper';
import InputEmployeeSearch from '../../includes/ui/InputEmployeeSearch';
import e from 'cors';
import DualCounterlogModal from './DualCounterlogModal';
import moment from 'moment';
import swal from "sweetalert";

const CounterlogModal                  =   forwardRef((props, ref) => {


    let initFormData                    =   {
        loading                         :   false,
        submitting                      :   false,

        asset_id                        :   null,
        shift_id                        :   null,
        feed_date                       :   null,
        remarks                         :   '',

        asset                           :   null,
        shift                           :   null,
        site                            :   null,
        available_meters                :   [],
        previous_cl                     :   null,
        latest_cl                       :   null,
        shift_cl                        :   null,
        shift_data                      :   null,
        absolute_running_cl             :   {},
        shift_reading                   :   null,

        shift_operator_required         :   "N",
        shift_operator_track            :   "N",
        operator_exist                  :   'Y',
        linked_employees                :   [],
        searched_operators              :   [],
        operator_ids                    :   [],


        copy_reading_checked            :   false,
        defective_meter                 :   "N",
        counterlogDate                  :   moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
        
    };


    //Edit Modal :-
    const [editModalId, setEditModalId]         =   useState(uuid());
    const editModalElem                         =   useRef(null);
    const editModal                             =   useRef(null);
    const editModalOpen                         =   ()  => editModal.current && editModal.current.show()
    const editModalClose                        =   ()  => editModal.current && editModal.current.hide()
    useEffect(() => {
        editModalElem.current                   =   document.getElementById(editModalId);
        editModal.current                       =   new Modal(editModalElem.current, {keyboard: false, backdrop :false});
        //Cleanup on unmount
        return () => {
            editModal.current && editModal.current.dispose();
        };
    }, []);
    const dualCounterlogModalRef            =   useRef(null);
    const access_token                      =   useSelector(state => state.auth.access_token);
    const app_setting                       =   useSelector(state => state.app.setting || []);
    const [formData, setFormData]           =   useState({...initFormData});
    const clFormDataAPI                     =   IAM_COUNTERLOG_URL + '/v2/add_form_data';
    const clDataSaveAPI                     =   IAM_COUNTERLOG_URL + "/v2/shift_reading";
    const clShiftReadingDeleteUrl           =   IAM_COUNTERLOG_URL + '/shift_detail/__replace_transaction_id';



    useImperativeHandle(ref, () => ({
        updateCounterlogInit: (shift, date, asset, editMode = false) => {
            if(editMode) { 
                openCounterLogModalHandler(shift, date, asset);
            } else {
                if(app_setting && app_setting.enable_opening_closing_cl && app_setting.enable_opening_closing_cl == 'Y') {
                    dualCounterlogModalRef.current.initModalHandler(shift.shift_id, date.date ? date.date : date, asset.asset_id);
                } else {
                    openCounterLogModalHandler(shift, date, asset);
                }
            }
        },
        deleteCounterlog: (transaction_id) => {
            deleteCounterlog(transaction_id)
        },
        initModalClose: () => {
            editModalClose();
            if(props.afterCounterlogSave) {
                let refreshDates            =   [];
                refreshDates.push(formData.shift.shift_date);
                props.afterCounterlogSave(refreshDates,formData.asset_id);
            }
        }
    }));

    const openCounterLogModalHandler            =   (shift, date, asset)  =>  {
        //CounterLog Dual Shift Add FormData :-
        counterLogFormData(shift.shift_id, date, asset.asset_id);
    }

    const counterLogFormData           =   (shift_id, feed_date, asset_id)  =>  {

        //Open Modal :-
        editModalOpen();
            
        //Call Api to get FormData :-
        let params                  =   {
            shift_id                    :   shift_id,
            feed_date                   :   feed_date && feed_date.date ? feed_date.date : feed_date ? feed_date :  moment(new Date(), 'YYYY-MM-DD').format('YYYY-MM-DD'),
            asset_id                    :   asset_id,
            get_previous_cl             :   'Y'
        }
        setFormData(pd => ({...pd, ...initFormData, loading : true, ...params }));
        
        HttpAPICall.withAthorization('GET', clFormDataAPI, access_token, params, {}, (resp) => {

            let respData            =   resp.data;
            let shift_data          =   respData.shift_data;
            let shift_reading       =   {};
            let absolute_running_cl =   {};
            let linked_employees    =   respData.linked_employees && respData.linked_employees.length > 0 
                                            ? respData.linked_employees 
                                            : [];
          
            let pre_selected_emp_ids        =   respData.shift_cl 
                                                ?   (shift_data.shift_operator_ids ? shift_data.shift_operator_ids : [])
                                                :   (respData.previous_cl_operator_ids && respData.previous_cl_operator_ids.length > 0 
                                                        ? respData.previous_cl_operator_ids
                                                        : [])   
            let searched_operators          =   linked_employees.filter(e =>  pre_selected_emp_ids.map(i => i).includes(e.enc_id));


           

            respData.available_meters.forEach((meter,k) => {
                let openMeterData           =   respData.shift_cl ? respData.shift_cl.find(r => r.key == meter.key) : null;
                let prevMeterData           =   respData.previous_cl ? respData.previous_cl.find(r => r.key == meter.key) : null;
                shift_reading[meter.key]    =   openMeterData ? openMeterData.reading : '';
                if(shift_data && shift_data.defective_meter == 'Y') {
                    absolute_running_cl[meter.key]  = (openMeterData ? openMeterData.cumulative : 0) - (prevMeterData ? prevMeterData.cumulative : 0);
                }
            });
            
            setFormData(pd => ({...pd,
                asset                   :   respData.asset,
                site                    :   respData.site,
                shift                   :   respData.shift,

                available_meters        :   respData.available_meters,
                previous_cl             :   respData.previous_cl,
                latest_cl               :   respData.latest_cl,
                shift_cl                :   respData.shift_cl,
                shift_reading           :   shift_reading,
                absolute_running_cl     :   absolute_running_cl,
                shift_data              :   shift_data,
                remarks                 :   shift_data ? shift_data.shift_remarks : '',
                defective_meter         :   shift_data ? shift_data.defective_meter : 'N',

                shift_operator_required :   respData.shift_operator_required,
                shift_operator_track    :   respData.shift_operator_track,
                linked_employees        :   [...new Map([...linked_employees, ...searched_operators].map(item => [item.id, item])).values()],
                operator_exist          :   shift_data ? shift_data.shift_operator_exist : 'Y',
                searched_operators      :   searched_operators.map(e => {
                                                return { label :    e.display_full_name, value : e.enc_id, employee : e };
                                            }),
                operator_ids            :   searched_operators.map(o => o.enc_id),
            }));
        } , (err) => {
            editModalClose();
        } ).then(() => {
            setFormData(pd => ({...pd, loading : false }));
        });
    }

    //2.7.1.11 - CounterLog Dual Shift Add FormData
    const clModalSubmitHandler                  =   (event)  =>  {
        event.preventDefault();
        let data                        =   TapHelper.pick(formData, ['asset_id', 'feed_date', 'shift_id', 'shift_reading', 'remarks', 'operator_exist', 'operator_ids', 'defective_meter']);

       
        setFormData(pd => ({...pd, submitting : true }));
        HttpAPICall.withAthorization('POST', clDataSaveAPI, access_token, {}, data, (resp) => {
            let refreshDates            =   [];
            refreshDates.push(formData.feed_date);
            afterSaveCounterlogHandler(refreshDates,formData.asset.asset_id);
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            editModalClose();
        }).then(() => {
            setFormData(pd => ({...pd, submitting : false }));
        });
    }

    const afterSaveCounterlogHandler  =   (dates, asset_id)  =>  {
        dates.forEach((date, i) => {
            let refreshAssetCard = false;
            if(formData.latest_cl) {
                let latest_date = DateService.dateTimeFormat(formData.latest_cl.find(r => r.key == 'feed_datetime').reading);
                var date1 = new Date(date);
                var date2 = new Date(latest_date);
                var same = date2 <= date1 ? true : false;
                refreshAssetCard = same == true ? true : false
            } else {
                refreshAssetCard    =    true;
            }
            setTimeout(() => {
                if(props.afterSubmitCounterlog) {
                    props.afterSubmitCounterlog(date, asset_id,refreshAssetCard);
                }
            }, 2500 * i);
        })
    }

    const deleteCounterlog      =   (transaction_id) => {
        swal({
            title: "Delete",
            text: "This action cannot be reversed, Are you sure you want to proceed?",
            icon: "warning",
             dangerMode: true,
            buttons: ["No", "Yes"],
        }).then(willDelete => {
            if (willDelete) {
                HttpAPICall.withAthorization('DELETE', clShiftReadingDeleteUrl.replace('__replace_transaction_id', transaction_id), access_token, {}, {}, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    if(props.afterDeleteCounterlog) {
                        props.afterDeleteCounterlog()
                    }
                    if (dualCounterlogModalRef.current) {
                        dualCounterlogModalRef.current.initModalClose();
                    }
                });
            }
        });
    }

    return <>
         <div className="modal fade" id={editModalId} tabIndex="-1" ref={editModalElem}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Update Counterlog for : {DateService.dateFormat(formData.feed_date)}
                        </h5>
                        <h5 className='text-end modal-title'>Site : {formData.site && formData.site.site_name} </h5>
                    </div>
                    <div className="modal-body py-0">
                        <form name='' id={editModalId + 'Form'} onSubmit={clModalSubmitHandler}>
                            {formData.loading ? <Loader /> : <>
                                <div className='border-bottom bg-light text-sm px-2' style={{marginLeft:"-15px", marginRight:"-15px"}}>
                                    <div className='row py-1'>
                                        <div className='col-sm-3'>Asset Name (Code)</div>
                                        <div className='col-sm-9 fw-bold'>{formData.asset && <>{formData.asset.name} ({formData.asset.asset_code})</>}</div>
                                    </div>
                                    <div className='row py-1'>
                                        <div className='col-sm-3'>Asset Type</div>
                                        <div className='col-sm-9 fw-bold'>{formData.asset && formData.asset.asset_type_name}</div>
                                    </div>
                                    <div className='row py-1'>
                                        <div className='col-sm-3'>Shift</div>
                                        <div className='col-sm-9 fw-bold'>
                                            {formData.shift && <>
                                                {formData.shift.shift_name}
                                                {" "} 
                                                ({DateService.dateFormat(formData.shift.shift_date)} {formData.shift.shift_start}
                                                )
                                            </>}
                                        </div>
                                    </div>
                                </div>
                                <div className='row my-3 mb-1'>
                                    <div className='offset-3 col-sm-4 text-sm form-text'>Previous Shift Reading</div>
                                    {formData.defective_meter == 'Y' && <div className='col-sm-2 text-sm form-text' style={{width:"20.83%"}}>Absolute Running</div> }
                                    <div className={["text-sm form-text", formData.defective_meter == 'N' ? "col-sm-5" : "col-sm-2"].join(" ")} style={{ width: formData.defective_meter == 'N' ? "41.66%" : "20.83%" }}>Counter log Reading</div>
                                </div>
                                {formData.available_meters.map((meter,i) => {
                                    let prevMeter       =   formData.previous_cl ? formData.previous_cl.find(r => r.key == meter.key) : null;
                                    let latestMeter     =   formData.latest_cl ? formData.latest_cl.find(r => r.key == meter.key) : null;
                                    return <div key={i} className='row my-2'>
                                        <label className="col-sm-3 text-sm require pt-2"><b>{meter.label}</b> ({meter.unit})</label>
                                        <div className='col-sm-4'>
                                            <input 
                                                className="form-control" value={prevMeter ? prevMeter.reading : ''}
                                                disabled={true}
                                                style={{ height: "30px", fontSize: "93%" }}
                                            />
                                            {formData.latest_cl && JSON.stringify(formData.latest_cl) != JSON.stringify(formData.previous_cl) && <small className="form-text">Latest Reading : {latestMeter.reading}</small>}
                                        </div>
                                        {formData.defective_meter === 'Y' && (
                                            <div className={'col-sm-2'} style={{ width: "20.83%" }}>
                                                <input
                                                    placeholder="Abs running"
                                                    disabled={formData.copy_reading_checked}
                                                    required={true}
                                                    style={{ height: "30px", fontSize: "93%" }}
                                                    value={ meter.key in formData.absolute_running_cl ? formData.absolute_running_cl[meter.key] : ''}
                                                    type="text"
                                                    className="form-control"
                                                    autoComplete="off"
                                                    onChange={(e) => {
                                                        setFormData(pd => ({ ...pd,
                                                            absolute_running_cl : {...formData.absolute_running_cl, [meter.key] : Number(e.target.value)},
                                                            shift_reading: { ...formData.shift_reading, [meter.key]: Number(prevMeter ? prevMeter.reading : 0) + Number(e.target.value) }
                                                        }));
                                                    }}
                                                />
                                            </div>
                                        )}
                                        <div className={formData.defective_meter == 'N' ? 'col-sm-5' : 'col-sm-2'} style={{ width:formData.defective_meter == 'N' ? "41.66%" : "20.83%" }} >
                                            <input  className="form-control"
                                                value={formData.shift_reading && formData.shift_reading[meter.key] ? formData.shift_reading[meter.key] : ''}
                                                onChange={(e) => {
                                                    setFormData(pd => ({
                                                        ...pd,
                                                        shift_reading: { ...formData.shift_reading, [meter.key]: e.target.value }
                                                    }));
                                                }}
                                                required={formData.shift}
                                                disabled={!formData.shift || formData.defective_meter == 'Y' || formData.copy_reading_checked}
                                                placeholder="Please Enter Reading"
                                                style={{ height: "30px", fontSize: "93%" }}
                                            />
                                        </div> 
                                    </div>
                                })}
                                <div className='row my-2'>
                                    <label className="col-sm-3 fw-bold text-sm pt-2">Counterlog Date</label>
                                    <div className="col-sm-4 add_calender_section">
                                        <DatePicker
                                            className="form-control form-control-sm"
                                            disabled={true}
                                            value={formData.previous_cl && DateService.dateTimeFormat(formData.previous_cl.find(r => r.key == 'feed_datetime').reading)}
                                        />
                                        <TapIcon.imageIcon icon={TapIcon.CalenderIcon} className="add_calender-icon" style={{ top: "5px" }} />
                                        {formData.latest_cl && JSON.stringify(formData.previous_cl) != JSON.stringify(formData.latest_cl) && <small className="form-text">Latest CL : {DateService.dateTimeFormat(formData.latest_cl.find(r => r.key == 'feed_datetime').reading)}</small>}
                                    </div>
                                    <div className="col-sm-5 add_calender_section">
                                        <DatePicker
                                            className="form-control form-control-sm"
                                            disabled={true}
                                            value={formData.shift && DateService.dateFormat(formData.shift.shift_date) + " "+ formData.shift.shift_start}
                                        />
                                        <TapIcon.imageIcon icon={TapIcon.CalenderIcon} className="add_calender-icon" style={{ top: "5px" }} />
                                    </div>
                                </div>
                                <div className='row my-2'>
                                    <label className="col-sm-3 form-label text-sm pt-2">Remark</label>
                                    <div className="col-sm-9">
                                        <textarea
                                            name="remarks"
                                            value={formData.remarks}
                                            className="form-control"
                                            autoComplete="off"
                                            placeholder="Please Enter Remark"
                                            onChange={(e) => DataService.handleFormState('remarks',e.target.value, formData, setFormData)}
                                        />
                                    </div>
                                </div>
                                {formData.shift_operator_track == 'Y' && <div className='row my-2'>
                                    <label className={['col-sm-3 form-label text-sm pt-2', formData.shift_operator_required == "Y" ? 'require' : ''].join(" ")}>Operator Name</label>
                                    <div className="col-sm-9">
                                        <InputEmployeeSearch
                                            placeholder="Please Select Employee"
                                            menuPlacement="top"
                                            containerHeight="36px"
                                            fontSize="93%"
                                            isMulti={true}
                                            disabled={formData.operator_exist == "N"}
                                            required={formData.shift_operator_required == "Y" && formData.operator_exist == 'Y' ? true : false}
                                            search_site_ids={[formData.site ? formData.site.id : null]} 
                                            transaction_date={formData.feed_date ? formData.feed_date : null}
                                            changeEvent={(so) => {
                                                setFormData(d => ({...d, 
                                                    operator_ids : so.map(e => e.value),
                                                    searched_operators : so && so.length > 0 ? so : [] 
                                                }))
                                            }}
                                            value={formData.searched_operators ? formData.searched_operators.map(a => { a.label = a.label; return a; }) : []}
                                            loadDefaultOptions={true}
                                            linkedEmployee={formData.linked_employees}
                                        />
                                        {formData.shift_operator_required =='Y' && <div className="form-check">
                                            <input
                                                id="id_shift_operator_required"
                                                className="form-check-input"
                                                type="checkbox"
                                                value={formData.operator_exist == "Y" ? "N" : "Y"}
                                                checked={formData.operator_exist == "N"}
                                                onChange={(e) => { 
                                                    setFormData(d => ({...d, 
                                                        operator_exist      :   e.target.value,
                                                        operator_ids        :   e.target.value == 'N' ? [] : formData.operator_ids,
                                                        searched_operators  :   e.target.value == 'N' ? [] : formData.searched_operators,
                                                    }));
                                                }}
                                            />
                                            <label className="form-check-label " htmlFor="id_shift_operator_required">Operator Not Available</label>
                                        </div>}
                                    </div>
                                </div>}
                            </>}
                        </form>
                    </div>
                    <div className="border-top p-2">
                        <div className='row'>
                            <div className='col-sm-6 text-start'>
                                <div className="form-check">
                                    <input
                                        id="id_defective_meter"
                                        className="form-check-input"
                                        type="checkbox"
                                        value={formData.defective_meter}
                                        checked={formData.defective_meter == 'Y'}
                                        onChange={(e) => {
                                            let absolute_running_cl     =   formData.absolute_running_cl;
                                            if(formData.defective_meter == 'N') {
                                                formData.available_meters.forEach(meter => {
                                                    let prevMeter       =   formData.previous_cl ? formData.previous_cl.find(r => r.key == meter.key) : null;
                                                    if(formData.shift_reading && formData.shift_reading[meter.key] > 0) {
                                                        absolute_running_cl[meter.key] =  Number(formData.shift_reading ? formData.shift_reading[meter.key] : 0) 
                                                                                            - Number(prevMeter ? prevMeter.reading : 0);
                                                    }
                                                });
                                            }
                                            setFormData(d => ({...d, defective_meter : formData.defective_meter == 'Y' ? 'N' : "Y", absolute_running_cl : absolute_running_cl}))
                                        }}
                                    />
                                    <label className="form-check-label " htmlFor="id_defective_meter">CounterLog Meter Defective</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        id="id_copy_reading_checked"
                                        className="form-check-input"
                                        type="checkbox"
                                        value={formData.copy_reading_checked}
                                        checked={formData.copy_reading_checked}
                                        onChange={(e) => { 
                                            setFormData(d => ({...d, copy_reading_checked : !formData.copy_reading_checked}));
                                            if(!formData.copy_reading_checked) {
                                                let data            =   {};
                                                let absolute_running_cl     =   {};
                                                formData.available_meters.forEach(meter => {
                                                    let prevMeter   =   formData.previous_cl ? formData.previous_cl.find(r => r.key == meter.key) : null;
                                                    data[meter.key] =   prevMeter ? prevMeter.reading : '';
                                                    absolute_running_cl[meter.key] =   0;
                                                });
                                                setFormData(d => ({...d, shift_reading : data, absolute_running_cl : absolute_running_cl}));
                                            }
                                        }}
                                    />
                                    <label className="form-check-label " htmlFor="id_copy_reading_checked">Copy Reading from Previous Shift</label>
                                </div>
                            </div>
                            <div className='col-sm-6 text-end'>
                                <button type="button" disabled={formData.submitting || formData.loading} className="btn btn-secondary me-2" onClick={editModalClose}>Close</button>
                                <button form={editModalId + 'Form'} disabled={formData.submitting || formData.loading} type="submit" className="btn btn-primary">Save {formData.submitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DualCounterlogModal 
            ref={dualCounterlogModalRef}
            deleteCounterlog={(transaction_id) => {
                deleteCounterlog(transaction_id);
            }}
            afterCounterlogSave={(dates, asset_id) => {
                afterSaveCounterlogHandler(dates,asset_id)
                // dates.forEach((date, i) => {
                //     let refreshAssetCard = false;
                //     if(this.state.latestCounterLog) {
                //         var date1 = new Date(date);
                //         var date2 = new Date(this.state.latestCounterLog.feed_date);
                //         var same = date2 <= date1 ? true : false;
                //         refreshAssetCard = same == true ? true : false
                //     } else {
                //         refreshAssetCard    =    true;
                //     }
                //     setTimeout(() => {
                //         if(props.afterSubmitCounterlog) {
                //             props.afterSubmitCounterlog(date, asset_id,refreshAssetCard);
                //         }
                //     }, 1000 * (i+1));
                // })
            }} 
        />
    </>
});

export default CounterlogModal;